import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-checkboxInput-control-label-view, [app-checkboxInput-control-label-view]',
  templateUrl: './checkboxInput-control-label-view.component.html',
  styleUrls: ['./checkboxInput-control-label-view.component.scss']
})
export class CheckboxInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
